import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Col, Row} from "reactstrap";

// import {getEntity} from "../../../services/entity/entity-service";

import PlayerCard from "../../components/player-card/player-card";

import {resetPlayerState, unarchivePlayer, getArchivedPlayers, getAssignedArchivedPlayers} from "../../../modules/player";
import {getSkills} from "../../../modules/system/skill";
import {setPageTitle} from "../../../modules/application/pages";

import "./player-archive.css";


class PlayerArchive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayName: null,
            therapistId: null,
            therapistPlayers: [],
            archivedPlayers: [],
            assignedArchivedPlayers: [],
            shouldGetArchivePlayers: true
        };

        this.unarchivePlayer = this.unarchivePlayer.bind(this)
    }

    componentWillMount() {
        this.props.dispatch(setPageTitle(`${this.props.currentUserFirstName}'s Archive`));
        this.props.dispatch(getSkills());
        this.props.dispatch(resetPlayerState());
    }


    async componentDidUpdate() {
        const {currentUserId, players, currentUserFirstName, token} = this.props;
        const {therapistId, therapistPlayers, displayName, shouldGetArchivePlayers} = this.state;

        if (currentUserFirstName !== displayName) {
            this.props.dispatch(setPageTitle(`${this.props.currentUserFirstName}'s Archive`));
            this.setState({displayName: currentUserFirstName});
        }

        if (shouldGetArchivePlayers) {
            this.setState({
                shouldGetArchivePlayers: false
            });
            let archivedPlayers = [];
            let assignedArchivedPlayers = [];
            let archivedPlayersResponse = await getArchivedPlayers(token);

            if (archivedPlayersResponse && archivedPlayersResponse.data && archivedPlayersResponse.data.success) {
                archivedPlayers = archivedPlayersResponse.data.players;
            }

            let assignedArchivedPlayersResponse = await getAssignedArchivedPlayers(token);

            if (assignedArchivedPlayersResponse && assignedArchivedPlayersResponse.data && assignedArchivedPlayersResponse.data.success) {
                assignedArchivedPlayers = assignedArchivedPlayersResponse.data.players;
            }

            this.setState({archivedPlayers: archivedPlayers, assignedArchivedPlayers: assignedArchivedPlayers});
        }

        if (currentUserId !== therapistId) {
            this.setState({therapistId: currentUserId});
        }

        if (players !== therapistPlayers) {
            this.setState({therapistPlayers: players});
        }
    }


    render() {
        let assignedArchivedPlayers = this.state.assignedArchivedPlayers;
        let archivedPlayers = this.state.archivedPlayers;


        return (   
            <div>
                <Row className="ml-1 mr-2 mt-3">
                    {archivedPlayers && archivedPlayers.map(player => (
                        <Col md="6" className="pr-2" key={player.id}>
                            <PlayerCard player={player}
                                        skills={this.props.skills}
                                        isArchive={true}
                                        archivePlayer={this.unarchivePlayer}
                            />
                            <br/>
                        </Col>
                    ))}
                </Row>

                {assignedArchivedPlayers && assignedArchivedPlayers.length > 0 && <div className='assigned_archived_players_section_title'>Assigned Players</div>}

                <Row className="ml-1 mr-2 mt-3">
                {this.state.assignedArchivedPlayers && this.state.assignedArchivedPlayers.map(player => (
                    <Col md="6" className="pr-2" key={player.id}>
                        <PlayerCard player={player}
                                    skills={this.props.skills}
                                    isArchive={true}
                                    archivePlayer={this.unarchivePlayer}
                        />
                        <br/>
                    </Col>
                ))}
                </Row>
            </div>
        );
    }

    async unarchivePlayer(playerId) {
        let {token} = this.props;
        await unarchivePlayer(playerId, token);
        this.props.history.push(`/therapistDashboard?message=Unarchived player!`)
        // const playerData = {
        //     is_archived: false
        // };
        // await getEntity(this.props.dispatch, updatePlayer(playerId, playerData));
        // this.props.history.push(`/therapistDashboard?message=Unarchived player!`)
    }
}

const withState = connect(state => {
    const {user, player, skill} = state;

    return {
        token: user.token,
        players: player.players,
        filter: player.filters,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
        skills: skill.skills
    };
});
export default withRouter(withState(PlayerArchive));



// WEBPACK FOOTER //
// ./src/components/containers/player-archive/player-archive.js